// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.11.2
//   protoc               v5.26.1
// source: portal/configs.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import { ConfigNode } from "../config/api/config_service";

export const protobufPackage = "carbon.portal.configs";

export interface ConfigResponse {
  config: ConfigNode | undefined;
  template?: ConfigNode | undefined;
  unsyncedKeys: UnsyncedKey[];
}

export interface UnsyncedKey {
  key: string;
  ts: number;
  oldValue: string;
  newValue: string;
}

export interface ConfigCrop {
  commonName: string;
  carbonName: string;
  id: string;
  pinned: string;
  recommended: string;
  isEnabled: boolean;
}

function createBaseConfigResponse(): ConfigResponse {
  return { config: undefined, template: undefined, unsyncedKeys: [] };
}

export const ConfigResponse: MessageFns<ConfigResponse> = {
  encode(message: ConfigResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.config !== undefined) {
      ConfigNode.encode(message.config, writer.uint32(10).fork()).join();
    }
    if (message.template !== undefined) {
      ConfigNode.encode(message.template, writer.uint32(18).fork()).join();
    }
    for (const v of message.unsyncedKeys) {
      UnsyncedKey.encode(v!, writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ConfigResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseConfigResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.config = ConfigNode.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.template = ConfigNode.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.unsyncedKeys.push(UnsyncedKey.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ConfigResponse {
    return {
      config: isSet(object.config) ? ConfigNode.fromJSON(object.config) : undefined,
      template: isSet(object.template) ? ConfigNode.fromJSON(object.template) : undefined,
      unsyncedKeys: globalThis.Array.isArray(object?.unsyncedKeys)
        ? object.unsyncedKeys.map((e: any) => UnsyncedKey.fromJSON(e))
        : globalThis.Array.isArray(object?.unsynced_keys)
        ? object.unsynced_keys.map((e: any) => UnsyncedKey.fromJSON(e))
        : [],
    };
  },

  toJSON(message: ConfigResponse): unknown {
    const obj: any = {};
    if (message.config !== undefined) {
      obj.config = ConfigNode.toJSON(message.config);
    }
    if (message.template !== undefined) {
      obj.template = ConfigNode.toJSON(message.template);
    }
    if (message.unsyncedKeys?.length) {
      obj.unsyncedKeys = message.unsyncedKeys.map((e) => UnsyncedKey.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ConfigResponse>, I>>(base?: I): ConfigResponse {
    return ConfigResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ConfigResponse>, I>>(object: I): ConfigResponse {
    const message = createBaseConfigResponse();
    message.config = (object.config !== undefined && object.config !== null)
      ? ConfigNode.fromPartial(object.config)
      : undefined;
    message.template = (object.template !== undefined && object.template !== null)
      ? ConfigNode.fromPartial(object.template)
      : undefined;
    message.unsyncedKeys = object.unsyncedKeys?.map((e) => UnsyncedKey.fromPartial(e)) || [];
    return message;
  },
};

function createBaseUnsyncedKey(): UnsyncedKey {
  return { key: "", ts: 0, oldValue: "", newValue: "" };
}

export const UnsyncedKey: MessageFns<UnsyncedKey> = {
  encode(message: UnsyncedKey, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.ts !== 0) {
      writer.uint32(16).uint64(message.ts);
    }
    if (message.oldValue !== "") {
      writer.uint32(26).string(message.oldValue);
    }
    if (message.newValue !== "") {
      writer.uint32(34).string(message.newValue);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UnsyncedKey {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUnsyncedKey();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.ts = longToNumber(reader.uint64());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.oldValue = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.newValue = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UnsyncedKey {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      ts: isSet(object.ts) ? globalThis.Number(object.ts) : 0,
      oldValue: isSet(object.oldValue)
        ? globalThis.String(object.oldValue)
        : isSet(object.old_value)
        ? globalThis.String(object.old_value)
        : "",
      newValue: isSet(object.newValue)
        ? globalThis.String(object.newValue)
        : isSet(object.new_value)
        ? globalThis.String(object.new_value)
        : "",
    };
  },

  toJSON(message: UnsyncedKey): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.ts !== 0) {
      obj.ts = Math.round(message.ts);
    }
    if (message.oldValue !== "") {
      obj.oldValue = message.oldValue;
    }
    if (message.newValue !== "") {
      obj.newValue = message.newValue;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<UnsyncedKey>, I>>(base?: I): UnsyncedKey {
    return UnsyncedKey.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<UnsyncedKey>, I>>(object: I): UnsyncedKey {
    const message = createBaseUnsyncedKey();
    message.key = object.key ?? "";
    message.ts = object.ts ?? 0;
    message.oldValue = object.oldValue ?? "";
    message.newValue = object.newValue ?? "";
    return message;
  },
};

function createBaseConfigCrop(): ConfigCrop {
  return { commonName: "", carbonName: "", id: "", pinned: "", recommended: "", isEnabled: false };
}

export const ConfigCrop: MessageFns<ConfigCrop> = {
  encode(message: ConfigCrop, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.commonName !== "") {
      writer.uint32(10).string(message.commonName);
    }
    if (message.carbonName !== "") {
      writer.uint32(18).string(message.carbonName);
    }
    if (message.id !== "") {
      writer.uint32(26).string(message.id);
    }
    if (message.pinned !== "") {
      writer.uint32(34).string(message.pinned);
    }
    if (message.recommended !== "") {
      writer.uint32(42).string(message.recommended);
    }
    if (message.isEnabled !== false) {
      writer.uint32(48).bool(message.isEnabled);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ConfigCrop {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseConfigCrop();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.commonName = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.carbonName = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.pinned = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.recommended = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.isEnabled = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ConfigCrop {
    return {
      commonName: isSet(object.commonName)
        ? globalThis.String(object.commonName)
        : isSet(object.common_name)
        ? globalThis.String(object.common_name)
        : "",
      carbonName: isSet(object.carbonName)
        ? globalThis.String(object.carbonName)
        : isSet(object.carbon_name)
        ? globalThis.String(object.carbon_name)
        : "",
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      pinned: isSet(object.pinned) ? globalThis.String(object.pinned) : "",
      recommended: isSet(object.recommended) ? globalThis.String(object.recommended) : "",
      isEnabled: isSet(object.isEnabled)
        ? globalThis.Boolean(object.isEnabled)
        : isSet(object.is_enabled)
        ? globalThis.Boolean(object.is_enabled)
        : false,
    };
  },

  toJSON(message: ConfigCrop): unknown {
    const obj: any = {};
    if (message.commonName !== "") {
      obj.commonName = message.commonName;
    }
    if (message.carbonName !== "") {
      obj.carbonName = message.carbonName;
    }
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.pinned !== "") {
      obj.pinned = message.pinned;
    }
    if (message.recommended !== "") {
      obj.recommended = message.recommended;
    }
    if (message.isEnabled !== false) {
      obj.isEnabled = message.isEnabled;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ConfigCrop>, I>>(base?: I): ConfigCrop {
    return ConfigCrop.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ConfigCrop>, I>>(object: I): ConfigCrop {
    const message = createBaseConfigCrop();
    message.commonName = object.commonName ?? "";
    message.carbonName = object.carbonName ?? "";
    message.id = object.id ?? "";
    message.pinned = object.pinned ?? "";
    message.recommended = object.recommended ?? "";
    message.isEnabled = object.isEnabled ?? false;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function longToNumber(int64: { toString(): string }): number {
  const num = globalThis.Number(int64.toString());
  if (num > globalThis.Number.MAX_SAFE_INTEGER) {
    throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
  }
  if (num < globalThis.Number.MIN_SAFE_INTEGER) {
    throw new globalThis.Error("Value is smaller than Number.MIN_SAFE_INTEGER");
  }
  return num;
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
